<!--suppress ALL -->
<template>
    <v-container>
        <v-layout>
            <v-flex offset-xs8 offset-md-6 xs4 md2 align-end>
                <v-label>Mês</v-label>
                <v-select
                        v-model="selected"
                        v-bind:style="{'margin-top':'5px'}"
                        item-text="text"
                        item-value="id"
                        min-length="0"
                        :rules="[rules.required]"
                        :items=items_meses
                        @change="selecionadoMes"
                        flat
                        solo>
                </v-select>
            </v-flex>
            <v-flex mt-4>
                <v-menu content-class="menu-card app-content"
                        min-width="450px"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        v-model="filtroDash">
                    <v-btn slot="activator" class="btn-default" color="dark" large outline>
                        <v-icon color="primary">lnr-funnel</v-icon>
                        <div class="pl-1">Filtrar</div>
                    </v-btn>
                    <v-layout column class="card">
                        <v-label>Informe o período personalizado:</v-label>
                        <v-layout mt-3 row wrap>
                            <v-flex mr-3>
                                <v-label>Data Inicial</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroDash.dash_data_ini"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>
                            <v-flex ml-3>
                                <v-label>Data Final</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroDash.dash_data_fim"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout mt-2 justify-center>
                            <v-flex xs4>
                                <v-btn class="btn-default" color="dark" outline @click="limparDash">Limpar</v-btn>
                            </v-flex>
                            <v-flex xs4>
                                <v-btn class="btn-default primary" @click="filtrarDash">Filtrar</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-menu>
            </v-flex>
        </v-layout>

        <v-layout column mt-1 class="card">
            <v-flex row md2 mt-2>
                <span class="subheading">Listagem de leads</span>
            </v-flex>
            <v-form ref="form">
                <v-layout row mt-4>
                    <v-flex mr-4>
                        <v-flex>
                            <span class="label-gestao">Diretor</span>
                        </v-flex>
                        <v-select
                                :disabled="!perfil_full_gestao_venda"
                                v-model="diretor"
                                item-text="nome"
                                item-value="id_usuario"
                                :items="diretores"
                                label="Todos os diretores"
                                @change="getReginal"
                                flat
                                solo
                        ></v-select>
                    </v-flex>
                    <v-flex mr-4>
                        <v-flex>
                            <span class="label-gestao">Gerente Regional</span>
                        </v-flex>
                        <v-select
                                :disabled="!perfil_full_gestao_venda && perfil_regional"
                                v-model="regional"
                                item-text="nome"
                                item-value="id_usuario"
                                :items="regionais"
                                label="Selecione um gerente regional"
                                @change="getGerentes"
                                flat
                                solo
                        ></v-select>
                    </v-flex>
                    <v-flex mr-4>
                        <v-flex>
                            <span class="label-gestao">Gerente</span>
                        </v-flex>
                        <v-select
                                :disabled="!perfil_full_gestao_venda && perfil_gerente"
                                v-model="gerente"
                                item-text="nome"
                                item-value="id_usuario"
                                :items="gerentes"
                                label="Selecione um gerente"
                                @change="getSupervisores"
                                flat
                                solo
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex mr-4>
                        <v-flex>
                            <span class="label-gestao">Supervisor</span>
                        </v-flex>
                        <v-select
                                :disabled="!perfil_full_gestao_venda && perfil_supervisor"
                                v-model="supervisor"
                                item-text="nome"
                                item-value="id_usuario"
                                :items="supervisores"
                                label="Selecione um supervisor"
                                @change="getVendedores"
                                flat
                                solo
                        ></v-select>
                    </v-flex>
                    <v-flex mr-4>
                        <v-flex>
                            <span class="label-gestao">Vendedor</span>
                        </v-flex>
                        <v-select
                                v-model="vendedor"
                                item-text="nome"
                                item-value="id_usuario"
                                :items="vendedores"
                                label="Selecione um vendedor"
                                @change="getVendedor"
                                flat
                                solo
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row mb-4>
                    <v-flex xs2 offset-xs8 offset-md-6 xs4 md2 align-end>
                        <v-btn class="btn-default" color="dark" outline @click="limparHierarquia">Limpar</v-btn>
                    </v-flex>
                    <v-flex xs2>
                        <v-btn class="btn-default primary" @click="buscar">Buscar</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs4 md3>
                        <v-layout mb-3>
                            <v-flex>
                                <v-menu content-class="menu-card mt-2 app-content flex"
                                        min-width="450px"
                                        transition="scale-transition"
                                        :close-on-content-click="false"
                                        offset-y
                                        full-width
                                        v-model="popupFiltro">
                                    <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                        <v-icon color="primary">lnr-funnel</v-icon>
                                        <div class="pl-1">Filtrar</div>
                                    </v-btn>
                                    <v-layout column class="card">
                                        <v-flex mb-4>
                                            <v-label>Data de distribuição</v-label>
                                            <v-text-field mb-4 ref="textField" v-model="filtro.data_distribuicao" flat solo
                                                          hide-details
                                                          mask="##/##/####"
                                                          return-masked-value
                                                          maxlength="10"
                                                          @keyup.enter="filtrar"></v-text-field>
                                        </v-flex>
                                        <v-flex mb-4>
                                            <v-label>E-mail</v-label>
                                            <v-text-field ref="textField" v-model="filtro.email" flat solo hide-details
                                                          maxlength="100"
                                                          @keyup.enter="filtrar"></v-text-field>
                                        </v-flex>
                                        <v-flex mb-4>
                                            <v-label>Nome</v-label>
                                            <v-text-field ref="textField" v-model="filtro['tb_lead.nome']" flat solo hide-details
                                                          maxlength="100"
                                                          @keyup.enter="filtrar"></v-text-field>
                                        </v-flex>
                                        <v-layout row wrap mt-4>
                                          <v-flex mr-3>
                                            <v-label mb-4>Leads que estão atualmente</v-label>

                                            <v-checkbox v-model="filtro.sla" value="true" label="Desvinculados por SLA" hide-details />
                                          </v-flex>
                                        </v-layout>
                                        <v-layout row wrap mt-4>
                                            <v-flex mr-3>
                                                <v-label mb-4>Status</v-label>

                                                <v-checkbox v-model="filtro.status['qualificar']" value="qualificar" label="Qualificar" hide-details />

                                                <v-checkbox v-model="filtro.status['qualificado_com_agendamento']" value="qualificado_com_agendamento" label="Qualificado com agendamento" hide-details />

                                                <v-checkbox v-model="filtro.status['em_negociacao']" value="em_negociacao" label="Em negociação" hide-details />
                                            </v-flex>
                                            <v-flex ml-3 mt-4>
                                                <v-checkbox v-model="filtro.status['negociacao_realizada']" value="negociacao_realizada" label="Negociação abandonada" hide-details />

                                                <v-checkbox v-model="filtro.status['qualificado']" value="qualificado" label="Qualificado" hide-details />
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap mt-4>
                                            <v-flex mr-3>
                                                <v-label mb-4>Origem</v-label>

                                                <v-checkbox v-model="filtro.origem['cadastro_vendedor']" value="cadastro_vendedor" label="Cadastro vendedor" hide-details />
                                            </v-flex>
                                            <v-flex ml-3 mt-4>
                                              <v-checkbox v-model="filtro.origem['bitrix']" value="bitrix" label="Bitrix" hide-details />
                                            </v-flex>
                                        </v-layout>
                                        <v-layout mt-3 justify-center>
                                            <v-flex xs4>
                                                <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-layout>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs3 offset-xs6>
                        <v-btn class="btn-default" color="primary" large @click.stop="dialogRemanejar()" v-if="this.checked.length > 0">
                            Remanejar Leads
                        </v-btn>
                    </v-flex>
                </v-layout>

                <v-layout mt-4 row mt-2>
                    <data-table-remanejamento ref="table" url="admin/leads/remanejamento"
                                              :filter="dtFiltro"
                                              :headers="headers"
                                              v-model="checked"
                                              :params="params"
                                              item-key="id_lead"
                                              sort-by="tb_lead_usuario_historico.data_hora_criacao"
                                              :descending="true"
                                              select-all>
                        <template slot="items" slot-scope="{ item }">
                            <td>{{ item.data_distribuicao | dia_mes_ano_hora_min }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.nome }}</td>
                            <td>{{ item.nome_vendedor }}<br>({{item.login }})</td>
                            <td>{{ item.nome_supervisor }}</td>
                            <td>{{ getStatus(item.status).text }}</td>
                        </template>
                    </data-table-remanejamento>
                </v-layout>
            </v-form>
        </v-layout>

        <v-dialog v-model="dialog" width="600" :scrollable="true" content-class="app-content" persistent>

            <v-card>
                <v-card-title class="headline primary white--text">
                    Remanejar Leads
                </v-card-title>

                <v-card-text>
                    Escolha para quem deseja <b>remanejar os leads</b> selecionados:

                    <v-flex xs12 md6>
                        <v-label>Protocolo de segurança</v-label>
                        <v-radio-group v-model="tipoRemanejamento" row>
                            <v-radio label="Supervisor" value="supervisor"/>
                            <v-radio label="Vendedor" value="vendedor"/>
                        </v-radio-group>
                    </v-flex>

                    <v-layout mt-4>
                        <v-flex mr-4>
                            <v-flex>
                                <label>Supervisor *</label>
                            </v-flex>
                            <v-select
                                    :disabled="!perfil_full_gestao_venda && perfil_supervisor"
                                    v-model="supervisorRemanejamento"
                                    item-text="nome"
                                    item-value="id_usuario"
                                    :items="supervisoresRemanejamento"
                                    label="Selecione um supervisor"
                                    @change="getVendedoresRemanejamento"
                                    :error-messages="erro_supervisor"
                                    flat
                                    solo>
                            </v-select>
                        </v-flex>
                    </v-layout>

                    <v-layout mt-4 v-if="tipoRemanejamento === 'vendedor'">
                        <v-flex mr-4>
                            <v-flex>
                                <label>Vendedor *</label>
                            </v-flex>
                            <v-select
                                    :disabled="!(this.supervisorRemanejamento.id_usuario !=0 && this.supervisorRemanejamento.id_usuario !='' && this.supervisorRemanejamento.id_usuario != null)"
                                    v-model="vendedorRemanejamento"
                                    item-text="nome"
                                    item-value="id_usuario"
                                    :items="vendedoresRemanejamento"
                                    label="Selecione um vendedor"
                                    @change="erro_vendedor = ''"
                                    :error-messages="erro_vendedor"
                                    flat
                                    solo>
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div ref="alert_actions" class="alert_actions">
                        <v-btn
                                class="btn-default"
                                color="dark"
                                outline
                                @click="dialog = false">
                            Cancelar
                        </v-btn>

                        <v-btn
                                class="btn-default primary"
                                primary
                                @click="confirmaRemanejamento()"
                                :disabled="confirmarDisabled">
                            Confirmar
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import Rules from '../plugins/validation'
import DataTableRemanejamento from './DataTableRemanejamento'
import { alert, sleep } from '../plugins/helpers'
import moment from 'moment'
import { LeadStatus } from '../constantes'

export default {
  components: { DataTableRemanejamento },
  data: () => ({
    tipoRemanejamento: 'supervisor',
    confirmarDisabled: false,
    dialog: false,
    id_usuario: '',
    selected: '',
    checked: [],
    vendedor: '',
    vendedores: [],
    supervisor: '',
    supervisores: [],
    gerente: '',
    id_usuario_supervisor: '',
    gerentes: [],
    diretor: '',
    diretores: [],
    regional: '',
    regionais: [],
    supervisorRemanejamento: '',
    supervisoresRemanejamento: [],
    vendedorRemanejamento: '',
    vendedoresRemanejamento: [],
    id_unidade_negocio: '',
    dtFiltro: {},
    dash_data_ini: '',
    dash_data_fim: '',
    dadosFiltroDash: {
      dash_data_ini: '',
      dash_data_fim: ''
    },
    filtro: {
      status: {},
      origem: {},
      sla: false
    },
    nome_cliente: '',
    filtroDash: false,
    perfil_full_gestao_venda: false,
    perfil_regional: false,
    perfil_gerente: false,
    perfil_supervisor: false,
    popupFiltro: false,
    erro_supervisor: '',
    erro_vendedor: '',
    headers: [
      { text: 'Data de distribuição', value: 'data_distribuicao' },
      { text: 'E-mail', value: 'email' },
      { text: 'Nome / Razão Social', value: 'nome' },
      { text: 'Vendedor', value: 'nome_vendedor' },
      { text: 'Supervisor', value: 'nome_supervisor' },
      { text: 'Status', value: 'status' }
    ],
    items_meses: [
      { text: 'Mostrar todas as datas', id: 13 },
      { text: 'Personalizado', id: '0' },
      { text: 'Janeiro', id: 1 },
      { text: 'Fevereiro', id: 2 },
      { text: 'Março', id: 3 },
      { text: 'Abril', id: 4 },
      { text: 'Maio', id: 5 },
      { text: 'Junho', id: 6 },
      { text: 'Julho', id: 7 },
      { text: 'Agosto', id: 8 },
      { text: 'Setembro', id: 9 },
      { text: 'Outubro', id: 10 },
      { text: 'Novembro', id: 11 },
      { text: 'Dezembro', id: 12 }
    ],
    listaStatusLead: [
      { text: 'Qualificar', id: LeadStatus.qualificar.status },
      { text: LeadStatus.desqualificado.desc, id: LeadStatus.desqualificado.status },
      { text: LeadStatus.qualificado.desc, id: LeadStatus.qualificado.status },
      { text: LeadStatus.qualificado_agendamento.desc, id: LeadStatus.qualificado_agendamento.status },
      { text: LeadStatus.em_negociacao.desc, id: LeadStatus.em_negociacao.status },
      { text: LeadStatus.negociacao_realizada.desc, id: LeadStatus.negociacao_realizada.status },
      { text: LeadStatus.cliente.desc, id: LeadStatus.cliente.status }
    ]
  }),
  computed: {
    rules: () => Rules,
    params () {
      return {
        id_usuario: this.id_usuario,
        id_unidade_negocio: this.id_unidade_negocio
      }
    }
  },
  filters: {
    dia_mes_ano_hora_min: function (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    }
  },
  watch: {
    filtroDash (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    },
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    confirmaRemanejamento () {
      if (this.checked.length === 0) {
        alert('Selecione os leads para remanejamento')
        this.dialog = false
      } else {
        let id_usuario = null
        let usuario = null
        this.dialog = false

        if (this.tipoRemanejamento === 'supervisor') {
          id_usuario = this.supervisorRemanejamento.id_usuario || null
          usuario = this.supervisoresRemanejamento.find((s) => s.id_usuario === id_usuario)
          this.erro_supervisor = !id_usuario || !usuario ? 'Campo obrigatório' : ''
        }

        if (this.tipoRemanejamento === 'vendedor') {
          id_usuario = this.vendedorRemanejamento || null
          usuario = this.vendedoresRemanejamento.find((s) => s.id_usuario === id_usuario)
          this.erro_vendedor = !id_usuario || !usuario ? 'Campo obrigatório' : ''
        }

        if (id_usuario && usuario) {
          usuario = usuario.nome
          alert({
            text: 'Os leads selecionados serão remanejados para o usuário ' + usuario + ', deseja confirmar?',
            buttons: {
              'Cancelar': () => true,
              'Confirmar': () => {
                this.enviaRemanejamento(id_usuario)
              }
            }
          })
        }
      }
    },
    enviaRemanejamento (id_usuario) {
      this.$http.post('/admin/leads/remanejar', {
        params: {
          id_usuario: id_usuario,
          ids_lead: this.checked,
          id_unidade_negocio: this.id_unidade_negocio
        }
      })
        .then((r) => {
          if (r.statusText === 'OK') {
            this.dialog = false
            alert({
              text: `Leads remanejados com sucesso`,
              buttons: {
                'Ok': () => { this.$router.go() }
              }
            })
          }
        }).catch((err) => {
          console.log(err)
          alert('Não foi possível atualizar o status')
        })
    },
    dialogRemanejar () {
      this.tipoRemanejamento = 'supervisor'
      this.dialog = true
      this.vendedoresRemanejamento = []
      this.getRequestsupervisoresRemanejamento()
    },
    filtrar () {
      this.popupFiltro = false
      if (this.dadosFiltroDash.dash_data_ini) {
        this.filtro.dash_data_ini = this.dadosFiltroDash.dash_data_ini
      } else {
        this.filtro.dash_data_ini = null
      }
      if (this.dadosFiltroDash.dash_data_fim) {
        this.filtro.dash_data_fim = this.dadosFiltroDash.dash_data_fim
      } else {
        this.filtro.dash_data_fim = null
      }
      this.recuperarHierarquia()
      this.dtFiltro = { ...this.filtro }
    },
    recuperarHierarquia () {
      this.filtro.regional = this.regional.id_regional || this.filtro.regional
      this.filtro.gerente = this.gerente.id_gerente || this.filtro.gerente
      this.filtro.supervisor = this.supervisor.id_supervisor || this.filtro.supervisor
      this.filtro.vendedor = this.vendedor.id_vendedor || this.filtro.vendedor
    },
    recuperarHierarquiaDash () {
      this.dadosFiltroDash.regional = this.regional.id_regional || this.filtro.regional
      this.dadosFiltroDash.gerente = this.gerente.id_gerente || this.filtro.gerente
      this.dadosFiltroDash.supervisor = this.supervisor.id_supervisor || this.filtro.supervisor
      this.dadosFiltroDash.vendedor = this.vendedor.id_vendedor || this.filtro.vendedor
    },
    limpar () {
      this.filtro = {
        status: {},
        origem: {}
      }
      this.filtrar()
    },
    selecionadoMes (option) {
      if (this.selected.id === 0) {
        this.limparDash()
      }
      if (option > 0 || option < 13) {
        let date = new Date()
        let data_inicial = new Date(date.getFullYear(), option - 1, 1)
        let data_final = new Date(date.getFullYear(), option, 0)
        this.dadosFiltroDash.dash_data_ini = moment(data_inicial).format('DD/MM/YYYY')
        this.dadosFiltroDash.dash_data_fim = moment(data_final).format('DD/MM/YYYY')
        this.dtFiltro = { ...this.dadosFiltroDash }
      }

      if (option === 13) {
        this.limparFiltroData()
      }
      if (option === '0') {
        this.filtroDash = true
      }
      this.selected = this.items_meses.find((s) => s.id === option) || {}
    },
    filtrarDash () {
      this.filtroDash = false
      this.selected = this.items_meses.find((s) => s.id === '0') || {}
      this.filtrar()
    },
    limparDash () {
      this.dadosFiltroDash = {
        dash_data_ini: [],
        dash_data_fim: []
      }
      this.recuperarHierarquiaDash()
      this.filtrarDash()
      this.getMesAtual()
    },
    limparFiltroData () {
      this.selected = 13
      this.dadosFiltroDash.dash_data_ini = null
      this.dadosFiltroDash.dash_data_fim = null
      this.limpar()
    },
    getMesAtual () {
      let data_atual = new Date()
      let data_inicial = new Date(data_atual.getFullYear(), data_atual.getMonth(), 1)
      let data_final = new Date(data_atual.getFullYear(), data_atual.getMonth() + 1, 0)
      this.dadosFiltroDash.dash_data_ini = moment(data_inicial).format('DD/MM/YYYY')
      this.dadosFiltroDash.dash_data_fim = moment(data_final).format('DD/MM/YYYY')
      this.filtrarDash()
      this.dtFiltro = { ...this.dadosFiltroDash }

      this.selected = this.items_meses.find((s) => s.id === data_atual.getMonth() + 1) || {}
    },
    getDiretores () {
      this.diretor = {}
      this.$http.get('admin/venda/gestao/diretores', {
        params: {
          id_usuario: this.id_usuario,
          id_unidade_negocio: this.id_unidade_negocio
        },
        options: { silent: true }
      }
      ).then((r) => {
        this.diretores = r.data
        if (this.diretores.length === 1) {
          this.diretor = this.diretores[0]
          this.getRequestRegional(this.diretor)
        }
      })
    },
    getReginal (option) {
      this.diretor = this.diretores.find((s) => s.id_usuario === option) || {}
      this.getRequestRegional(this.diretor)
    },
    getRequestRegional (diretor) {
      this.$http.get('/admin/venda/gestao/regional', {
        params: {
          id_diretor: diretor.id_diretor
        },
        options: { silent: true }
      })
        .then((r) => {
          this.regionais = this.getHierarquiaVazia(r.data)
          this.regional = this.regionais.find((s) => s.id_regional === this.filtro.regional) || {}
          if (this.regionais.length === 1) {
            this.regional = this.regionais[0]
          }
          this.getRequestGerentes(this.regional)
        })
    },
    getGerentes (option) {
      this.regional = this.regionais.find((s) => s.id_usuario === option) || {}
      this.getRequestGerentes(this.regional)
    },
    getRequestGerentes (regional) {
      this.$http.get('/admin/venda/gestao/gerentes', {
        params: {
          id_regional: regional.id_regional
        },
        options: { silent: true }
      })
        .then((r) => {
          this.gerentes = this.getHierarquiaVazia(r.data)
          this.gerente = this.gerentes.find((s) => s.id_gerente === this.filtro.gerente) || {}
          if (this.gerentes.length === 1) {
            this.gerente = this.gerentes[0]
          }
          this.getRequestSupervisores(this.gerente)
        })
    },
    getSupervisores (option) {
      this.gerente = this.gerentes.find((s) => s.id_usuario === option) || {}
      this.getRequestSupervisores(this.gerente)
    },
    getRequestSupervisores (gerente) {
      this.$http.get('/admin/venda/gestao/supervisores', {
        params: {
          id_gerente: gerente.id_gerente
        },
        options: { silent: true }
      }).then((r) => {
        this.supervisores = this.getHierarquiaVazia(r.data)
        this.supervisor = this.supervisores.find((s) => s.id_supervisor === this.filtro.supervisor) || {}
        if (this.supervisores.length === 1) {
          this.supervisor = this.supervisores[0]
        }
        this.getRequestVendedores(this.supervisor)
      })
    },
    getVendedor (option) {
      this.vendedor = this.vendedores.find((s) => s.id_usuario === option) || {}
    },
    getHierarquiaVazia (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].nome === null) {
          data[i].nome = 'Hierarquia vazia'.toUpperCase()
        }
      }
      return data
    },
    getVendedores (option) {
      this.supervisor = this.supervisores.find((s) => s.id_usuario === option) || {}
      this.getRequestVendedores(this.supervisor)
    },
    getRequestVendedores (supervisor) {
      this.$http.get('/admin/venda/gestao/vendedores', {
        params: {
          id_supervisor: supervisor.id_supervisor
        },
        options: { silent: true }
      })
        .then((r) => {
          this.vendedores = r.data
          this.vendedor = this.vendedores.find((s) => s.id_vendedor === this.filtro.vendedor) || {}
          if (this.vendedores.length === 1) {
            this.vendedor = this.vendedores[0]
          }
        })
    },
    getRequestsupervisoresRemanejamento () {
      this.$http.get('/admin/leads/remanejamento/supervisores', {
        params: {
          id_unidade_negocio: this.id_unidade_negocio
        }
      }).then((r) => {
        this.supervisoresRemanejamento = this.getHierarquiaVazia(r.data)
        if (this.id_usuario_supervisor !== '') {
          this.supervisorRemanejamento = this.supervisoresRemanejamento.find((s) => s.id_supervisor === this.id_usuario_supervisor) || {}
          this.getRequestVendedoresRemanejamento(this.supervisorRemanejamento)
        } else {
          this.supervisorRemanejamento = this.supervisoresRemanejamento.find((s) => s.id_supervisor === this.supervisoresRemanejamento) || {}
        }
        if (this.tipoRemanejamento === 'vendedor') {
          this.getRequestVendedoresRemanejamento(this.supervisorRemanejamento)
        }
      })
    },
    getVendedoresRemanejamento (option) {
      this.erro_supervisor = ''
      this.supervisorRemanejamento = this.supervisoresRemanejamento.find((s) => s.id_usuario === option) || {}
      this.getRequestVendedoresRemanejamento(this.supervisorRemanejamento)
    },
    getRequestVendedoresRemanejamento (supervisor) {
      this.$http.get('/admin/leads/remanejamento/vendedores', {
        params: {
          id_supervisor: supervisor.id_supervisor
        }
      })
        .then((r) => {
          this.vendedoresRemanejamento = r.data
          this.vendedorRemanejamento = this.vendedoresRemanejamento.find((s) => s.id_vendedor === this.vendedoresRemanejamento) || {}
        })
    },
    buscar () {
      this.dadosFiltroDash.nome_cliente = this.nome_cliente
      this.dadosFiltroDash.regional = this.regional.id_regional || this.filtro.regional
      this.dadosFiltroDash.gerente = this.gerente.id_gerente || this.filtro.gerente
      this.dadosFiltroDash.supervisor = this.supervisor.id_supervisor || this.filtro.supervisor
      this.dadosFiltroDash.vendedor = this.vendedor.id_vendedor || this.filtro.vendedor
      this.dadosFiltroDash.mes = this.selected || this.filtro.mes
      this.dtFiltro = { ...this.dadosFiltroDash }
    },
    limparHierarquia () {
      this.nome_cliente = ''
      this.vendedor.id_vendedor = ''
      this.vendedores = []
      this.supervisor = ''
      this.supervisores = []
      this.gerente.id_gerente = ''
      this.gerentes = []
      this.diretor.id_diretor = ''
      this.diretores = []
      this.regional.id_regional = ''
      this.regionais = []
      this.getDiretores()
      this.buscar()
    },
    getStatus (status) {
      return this.listaStatusLead.find((s) => s.id === status) || ''
    }
  },
  mounted () {
    this.id_usuario = this.$session.get('id_usuario')
    this.id_unidade_negocio = this.$session.get('id_unidade_negocio')
    if (this.$route.params['filtros']) {
      const filtro = this.$route.params['filtros']
      this.filtro = { ...filtro }
      this.nome_cliente = filtro.nome_cliente
      this.dadosFiltroDash.dash_data_ini = filtro.dash_data_ini
      this.dadosFiltroDash.dash_data_fim = filtro.dash_data_fim
      this.filtrarDash()
      this.getDiretores()
      this.buscar()
    } else {
      this.limparFiltroData()
      this.getDiretores()
    }
    this.$http.get('admin/perfis/verifica', {
      params: {
        id_unidade_negocio: this.id_unidade_negocio
      },
      options: { silent: false }
    }).then((r) => {
      this.perfil_full_gestao_venda = r.data.perfil
      if (!this.perfil_full_gestao_venda && !this.$route.params['filtros']) {
        if (r.data.id_regional != null && r.data.id_regional !== 0 && r.data.id_regional !== '') {
          this.filtro.regional = r.data.id_regional
          this.perfil_regional = true
        }
        if (r.data.id_gerente != null && r.data.id_gerente !== 0 && r.data.id_gerente !== '') {
          this.filtro.gerente = r.data.id_gerente
          this.perfil_gerente = true
        }
        if (r.data.id_supervisor != null && r.data.id_supervisor !== 0 && r.data.id_supervisor !== '') {
          this.filtro.supervisor = r.data.id_supervisor
          this.id_usuario_supervisor = this.filtro.supervisor
          this.perfil_supervisor = true
        }
        this.getDiretores()
        this.buscar()
      }
    })
  }
}
</script>

<style scoped>
.subheading {
    font-style: normal;
    font-weight: bold;
    color: #757575;
}

.label-gestao {
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    color: #757575;
}
</style>
